import React, { useEffect, useState, useContext } from 'react';
import '../styles/MyPicks.css';
import { getAllNomineesAndCategories, getPartyById, getUserPicks, postUserPicks } from '../apiCalls/partyAPI';
import CategoryNominees from '../entities/categoryNominees';
import AuthContext, {CacheContext} from '../contexts/index';
import Pick from '../entities/pick';
import UserPicks from '../entities/userPicks';
import { useParams } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';

export const getMissingPicksCount = (picks, totalCategories) => {
    const pickedCategories = picks.filter(p => p.name && p.name !== 'Select A Nominee').length;
    return totalCategories - pickedCategories;
}

function MyPicks() {
    const { partyId } = useParams();
    const [isDisabled, setIsDisabled] = useState(false);
    const visible = { visibility: 'visible' };
    const hidden = { visibility: 'hidden' };
    const [modalShow, setModalShow] = useState(hidden);
    const { user } = useContext(AuthContext);
    const { activeParty, setActiveParty } = useContext(CacheContext);
    const [ nomineesAndCategories, setNomineesAndCategories ] = useState();
    const [ myPicks, setMyPicks ] = useState([]);
    const [ picksWarning, setPicksWarning ] = useState(null);
    const navigate = useNavigate();

    useEffect(()=>{
        if(!activeParty?.id){
            getPartyById(partyId, user.credential)
            .then(party => {
                setActiveParty(party);
            })
        }
    },[]);


    useEffect(() => {
        setModalShow(visible);
        if(activeParty?.id){
            getAllNomineesAndCategories(activeParty.oscarYear, user.credential)
            .then(nominees => nominees.map(nominee => new CategoryNominees(nominee._id, nominee.category, nominee.oscarYear, nominee.nominees)))
            .then(nominees => setNomineesAndCategories(nominees))
            .then(() => loadUserPicks())
            .finally(() => setModalShow(hidden))
            .catch(error => console.log(error));
        }
    }, [user, activeParty]);
    
    const loadUserPicks = () => {
        if(user){
            getUserPicks(user.email, activeParty.id, user.credential)
            .then(({picks}) => picks.forEach(pick => setPicks(pick)))
            .catch(error => console.log(error));
        }
    }

    const setPicks = (pick) => {
        const select = document.getElementById(pick.category);
        select.value = pick.name;
        setMyPicks(picks => [...picks, pick]);
    }

    const handleSubmit = (e) => {
        e.preventDefault();
        const totalCategories = nomineesAndCategories ? nomineesAndCategories.length : 23;
        const missing = getMissingPicksCount(myPicks, totalCategories);
        if (missing > 0) {
            setPicksWarning(`You have ${missing} ${missing === 1 ? 'category' : 'categories'} without a pick. You can still save, but you may miss points!`);
        } else {
            setPicksWarning(null);
        }
        setModalShow(visible);
        setIsDisabled(true);
        postUserPicks(new UserPicks(user.email, activeParty.id, myPicks), user.credential)
        .then(() => navigate("/party/view/"+activeParty.id))
        .finally(() => setModalShow(hidden))
        .catch(error => console.log(error));
    }

    const screamingSnakeToPretty = (screamingSnake) => {
        return screamingSnake.replace(/_/g, " ");
    }

    const updatePicks = (pick) => {
        //replace pick in picks array if it already exists
        const index = myPicks.findIndex(p => p.category === pick.category);
        if(index >= 0){
            let newPicks = [...myPicks];
            newPicks[index] = pick;
            setMyPicks(newPicks);
        }else{
            setMyPicks(picks => [...
                picks, pick
            ]);
        }
        
    }

    return (
        <>
            <span className="loader" style={modalShow}></span>
            {
                nomineesAndCategories
                ?
                    <div className="container">
                        <h1>My {nomineesAndCategories[0].oscarYear} Oscar Picks</h1>
                        <div className='row'>
                            <div className="col-md-6">
                                { picksWarning && (
                                    <div className="alert alert-warning" data-testid="picks-warning" role="alert">
                                        {picksWarning}
                                    </div>
                                )}
                                <form id="myPicks" onSubmit={handleSubmit}>
                                    {
                                        nomineesAndCategories.map(cat => 
                                            <div className="form-group" key={cat._id}>
                                                <label htmlFor="queryName">{screamingSnakeToPretty(cat.category)}</label>
                                                <select id={cat.category} name={cat.category} data-testid={cat.category+"-select"} className='form-control' onChange={ (e) => updatePicks(new Pick(cat.category, e.target.value))} >
                                                    <option value="Select A Nominee" data-testid={cat.category+"-select-default"}>Select a Nominee</option>
                                                    {
                                                        cat.nominees.map((nominee,index) => <option value={nominee.name} key={index} data-testid={cat.category+index}>{nominee.name.toUpperCase()}{nominee.name2 ? " - "+nominee.name2 : ""}</option>)    
                                                    }
                                                </select>
                                            </div>
                                        )
                                    }
                                    <div className="form-group">
                                        <button type="submit" className="btn btn-success" data-testid="saveButton" disabled={isDisabled}>Save</button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                :
                    <>Loading</>
            }
        </>
    );
}

export default MyPicks;
